import { render, staticRenderFns } from "./FooterButton.vue?vue&type=template&id=e5dcc6f0&scoped=true&"
import script from "./FooterButton.vue?vue&type=script&lang=js&"
export * from "./FooterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dcc6f0",
  null
  
)

export default component.exports